import axios from "axios";

export const callExternalApi = async (url, methodType, params) => {
  try {
    const response = await axios({
      url,
      method: methodType,
      params: methodType === "GET" ? params : null,
      data: methodType === "POST" ? params : null,
      timeout: 10000,
    });
    return response;
  } catch (error) {
    if (error.response) {
      console.error('Response data:', error.response.data);
    }
    throw error;
  }
};
